import React from "react";

// redux
import { Provider } from 'react-redux';
import store from './store';

import PricingContent from './PricingContent';
const Pricing = () => {

  return (
    <Provider store={store}>
      <PricingContent></PricingContent>
    </Provider>
  );
};

export default Pricing;
